<template>
    <!--
        @event export
        @property {string} type The export type (`pdf` or `csv`)
     -->
    <RPDropdownButton
        :options="options"
        type="tertiary"
        :default-icon="downloadIcon"
        default-label="Export"
        :default-icon-color="grey200"
        :hide-arrow="true"
        @input="e => $emit('export', e)"
    />
</template>
<script>
import RPDropdownButton from 'components/Basic/Buttons/DropdownButton/RPDropdownButton.vue';
import {DownloadBottom} from "@reviewpush/streamline-regular/lib/internet-networks-servers/UploadDownload";
import {OfficeFilePdf1} from "@reviewpush/streamline-regular/lib/work-office-companies/OfficeFiles";
import {FileCsv} from "@reviewpush/streamline-regular/lib/programing-apps-websites/CodingFiles";
import colors from 'style/_colors.scss';

export default {
    name: 'RPExportButton',
    components: {
        RPDropdownButton
    },
    data(){
        return {
            downloadIcon: DownloadBottom,
            grey200: colors.grey200,
            options: [
                {
                    label: 'PDF',
                    value: 'pdf',
                    icon: OfficeFilePdf1,
                },
                {
                    label: 'CSV',
                    value: 'csv',
                    icon: FileCsv,
                },
            ],
        };
    },
};
</script>
<style lang="scss">
    .ExportButton {
    }
</style>

<docs>
```vue
<RPExportButton />
```
</docs>
